import InputField from 'components/common/input-field';
import CommonLayout from './common-layout';
import { useAppSelector, useAppDispatch } from 'hooks/useAppDispatchSelector';
import Select, { IDefaultOption } from 'components/common/select';
import { useContext, useState, useEffect } from 'react';
import MultiSelect from 'components/common/multi-select';
import DatePickerComponent from 'components/common/date-picker';
import TextEditor from 'components/common/rich-text-editor.tsx';
import CheckBox from 'components/common/checkbox';
import { AppContext } from 'context/app-context';
import { ReactComponent as CancelIcon } from 'assets/icon/cancel.svg';
import { ReactComponent as FileIcon } from 'assets/icon/file-icon.svg';
import { ReactComponent as TrashIcon } from 'assets/icon/trash.svg';
import { ReactComponent as SearchIcon } from 'assets/icon/search.svg';
import { getBrandList, getEngineList, getTireSizeList } from 'store/features/vehicleConfigSlice';
import { createOfferAndTips, uploadOfferAndTipsMedia } from 'store/features/alertsSlice';
import {
  ICreateEditOfferAndTipRequest,
  ITipsAndOffers,
  ITipsAndOffersErrors,
  initOfferData,
} from 'interfaces/alerts-campaigns-interface';
import { initSideModal, usersRoles } from 'helpers/utils';
import { getOrganizationListWithAssociateParking } from 'store/features/administratorRoleSlice';
import moment from 'moment';
import { setPreviewFileData, setSideModal } from 'store/features/modelSlice';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import CloudUpload from 'components/common/cloud-upload';
import { fi } from 'date-fns/locale';
import { IUploadMediaResponse } from './add-edit-workshop-appointment';
import { IUploadImageRequestParam } from 'store/features/organizationSlice';

const AddEditOffersTips = () => {
  const { setLoader } = useContext(AppContext);
  const dispatch = useAppDispatch();
  const {
    sideModal: {
      content: { formFor, callBackFun },
    },
  } = useAppSelector(state => state.modal);
  const { brands, tireSizes, engines } = useAppSelector(state => state.vehicleConfig);
  const { selectedOrganization } = useAppSelector(state => state.auth);
  const { organizationAssociateParking } = useAppSelector(state => state.adminRole);

  const [offersData, setOfferData] = useState<ITipsAndOffers>(initOfferData);
  const [error, setError] = useState<ITipsAndOffersErrors | null>(null);
  const [timeValue, setTimeValue] = useState<string>('');
  const [contentText, setContentText] = useState<string>('');
  const [brandOptions, setBrandOptions] = useState<IDefaultOption[]>([]);
  const [engineOptions, setEngineOptions] = useState<IDefaultOption[]>([]);
  const [tireSizeOptions, settireSizeOptions] = useState<IDefaultOption[]>([]);
  const [organizationOptions, setOrganizationOption] = useState<IDefaultOption[]>([]);
  const [showPdfUpload, setShowPdfUpload] = useState(false);
  const [showDescription, setShowDescription] = useState(false);

  const { t } = useTranslation();

  const isSuperAdmin = selectedOrganization?.role_name === usersRoles.SUPER_ADMIN ? true : false;
  const isDealerAdmin = selectedOrganization?.role_name === usersRoles.DEALER_ADMIN ? true : false;
  const [file, setFile] = useState<File | null>(null);
  const handleTimeChange: React.ChangeEventHandler<HTMLInputElement> = e => {
    const time = e.target.value;
    setTimeValue(time);
  };
  const getOrganizationListAndParking = async () => {
    try {
      let params = isDealerAdmin ? { organization_id: selectedOrganization?.organization_id } : {};
      if (isDealerAdmin || isSuperAdmin) {
        await dispatch(
          getOrganizationListWithAssociateParking({
            params,
          }),
        ).catch(() => {
          setLoader(false);
        });
      }
      return Promise.resolve(true);
    } catch (error) {
      setLoader(false);
      return Promise.reject(false);
    }
  };

  const fetchOptions = async () => {
    try {
      setLoader(true);
      await Promise.all([
        getOrganizationListAndParking(),
        dispatch(getBrandList({})),
        dispatch(getEngineList({})),
        dispatch(getTireSizeList({})),
      ]).catch(() => setLoader(false));
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchOptions();
  }, []);
  useEffect(() => {
    const formatedBrandOptions =
      brands.map(data => ({ id: data?._id || '', name: data?.name || '' })) || [];
    setBrandOptions(formatedBrandOptions);
  }, [brands]);
  useEffect(() => {
    const formatedEngineOptions =
      engines.map(data => ({ id: data?._id || '', name: data?.name || '' })) || [];
    setEngineOptions(formatedEngineOptions);
  }, [engines]);
  useEffect(() => {
    const formatedTireSizeOptions =
      tireSizes.map(data => ({ id: data?._id || '', name: data?.name || '' })) || [];
    settireSizeOptions(formatedTireSizeOptions);
  }, [tireSizes]);
  useEffect(() => {
    const updatedOptions = organizationAssociateParking.map(data => ({
      id: data?._id || data?.id,
      name: data?.organization_name || data?.name,
      value: data?._id || data?.id,
    }));
    setOrganizationOption(updatedOptions);
  }, [organizationAssociateParking]);
  const getError = () => {
    const updatedError: ITipsAndOffersErrors = {
      title: !offersData?.title?.trim() ? t('offersAndTips.addEdit.errorTitleToastMessage') : '',
      organization: !offersData?.organizations?.length
        ? t('offersAndTips.adddEdit.errorSelectOrganizationToastMessage')
        : '',
      publishDate: !offersData?.publishDate?.trim()
        ? t('offersAndTips.addEdit.errorPublishDateToastMessage')
        : !timeValue?.trim()
        ? t('offersAndTips.addEdit.errorPublishTimeToastMessage')
        : '',
      type: !offersData?.type ? t('offersAndTips.addEdit.errorTypeToastMessage') : '',
      contentText: !contentText?.trim() ? t('offersAndTips.addEdit.errorContentTextMessage') : '',
      // type: !offersData?.type ? 'Please select type' : '',
    };
    setError(updatedError);
  };
  const isValid = () => {
    getError();
    if (
      !offersData?.title?.trim() ||
      (!isDealerAdmin && !offersData?.organizations?.length) ||
      !offersData?.publishDate?.trim() ||
      !offersData?.type?.id?.trim() ||
      !timeValue?.trim()
    ) {
      return false;
    } else {
      return true;
    }
  };

  const uploadMediaForAdd = async () => {
    try {
      if (file) {
        const uploadMediaParam = {
          request: {
            file_name: file?.name || '',
            file_type: file?.type || '',
            file_size: file?.size || 0,
          },
          file: file,
        };

        const mediaResponse: IUploadMediaResponse = await dispatch(
          uploadOfferAndTipsMedia({ params: uploadMediaParam }),
        );
        return Promise.resolve(mediaResponse);
      } else return Promise.resolve(null);
    } catch (error) {
      return Promise.reject(error);
    }
  };

  const handlePdfCheckboxChnage = () => {
    setShowPdfUpload(prev => !prev);
    setShowDescription(false);
  };

  const handleDescriptionCheckboxChnage = () => {
    setShowDescription(prev => !prev);
    setShowPdfUpload(false);
  };
  const handleSubmit = async () => {
    if (!isValid()) {
      return;
    }

    setLoader(true);
    if (!showDescription && !showPdfUpload) {
      toast.error('Please upload a file or add a description');
      setLoader(false);
      return;
    }

    const uploadMedia = await uploadMediaForAdd().catch(err => {
      return;
    });

    if (!offersData?.is_email && !offersData?.is_notification) {
      toast.error(t('offersAndTips.addEdit.errorOfferSendToastMessage'));
      return;
    }

    setLoader(true);

    let request: ICreateEditOfferAndTipRequest = {
      title: offersData?.title,
      is_email: false,
      is_notification: true,
      organization_ids: isDealerAdmin && selectedOrganization?.organization_id 
        ? [selectedOrganization.organization_id]
        : offersData?.organizations?.map(data => data?.id) || [],
      sent_at: moment(
        `${moment(offersData?.publishDate).format('YYYY-MM-DD')} ${timeValue}`,
        'YYYY-MM-DD HH:mm',
      ).toISOString(),
      type: offersData?.type?.id || '',
    };

    if (showPdfUpload && uploadMedia?.key) {
      request.pdf_id = uploadMedia.key;
    } else {
      request.description = contentText;
    }

    if (offersData?.brand?.id) {
      request = { ...request, brand: offersData?.brand?.id || '' };
    }
    if (offersData?.engine?.id) {
      request = { ...request, engine: offersData?.engine?.id || '' };
    }
    if (offersData?.rearTireSize?.id) {
      request = { ...request, rear_tire_size: offersData?.rearTireSize?.id || '' };
    }
    if (offersData?.frontTireSize?.id) {
      request = { ...request, front_tire_size: offersData?.frontTireSize?.id || '' };
    }
    await dispatch(
      createOfferAndTips({
        request: { ...request },
      }),
    ).catch(() => setLoader(false));
    if (callBackFun) {
      callBackFun();
    }
    dispatch(setSideModal(initSideModal));
    toast.success(t('offersAndTips.addEdit.successOfferCreated'));
    setLoader(false);
  };

  const handleSetFile = (file: File | null) => {
    setFile(file);
  };

  const handlePreviewFile = (file: File, type: string) => {
    dispatch(
      setPreviewFileData({
        type: type || '',
        content: { url: window.URL.createObjectURL(file) },
      }),
    );
  };

  const getFileContent = (file: File | null) => {
    if (file) {
      const splitedVal = file.type.split('/');
      if (splitedVal[0] === 'application') {
        return (
          <button
            className="flex items-center justify-center w-7 h-7 rounded-full bg-grey1 cursor-pointer"
            onClick={() => handlePreviewFile(file, splitedVal[0])}
          >
            <SearchIcon />
          </button>
        );
      }
    }
    return null;
  };
  const handleRemoveFile = () => {
    setFile(null);
  };

  const isFileSelected = !!file;
  return (
    <CommonLayout
      onConfirm={handleSubmit}
      confirmButtonProps={{
        label:
          formFor === 'EDIT'
            ? t('offersAndTips.addEdit.saveChanges')
            : t('offersAndTips.addEdit.create'),
      }}
    >
      <div className="flex flex-wrap w-full h-full p-6">
        <div className="flex flex-wrap w-full px-3 mt-4">
          {/* <label className="text-sm text-black2 break-words font-medium">Upload Pdf Only</label> */}
          <div className="mb-3 flex w-1/2">
            <input
              type="checkbox"
              id="pdfUpload"
              checked={showPdfUpload}
              onChange={handlePdfCheckboxChnage}
            />
            <label className="ml-2  font-medium text-black">
              {t('offersAndTips.addEdit.uploadPdf')}
            </label>
          </div>
          <div className="mb-3 flex w-1/2">
            <input
              type="checkbox"
              id="description"
              checked={showDescription}
              onChange={handleDescriptionCheckboxChnage}
            />
            <label className="ml-2  font-medium text-black">
              {t('offersAndTips.addEdit.addDesc')}
            </label>
          </div>
          {!isFileSelected && showPdfUpload && (
            <div className="flex w-full">
              <CloudUpload
                setFile={e => {
                  const file = e.target.files && e.target.files[0];
                  if (file) {
                    handleSetFile(file);
                  } else {
                    handleSetFile(null);
                  }
                }}
                title={t('ADD_EDIT_OFFERS_TIPS_MODAL_TITLE')}
                acceptedFile=".pdf"
              />
            </div>
          )}

          {showDescription && (
            <div className="flex flex-wrap w-full ">
              <TextEditor
                textEditorValue={contentText}
                setTextEditorValue={data => setContentText(data)}
                height={'h-60'}
              />
              {/* {error?.contentText && (
                <p className=" font-regular text-xs text-red-500">{error?.contentText}</p>
              )} */}
            </div>
          )}

          <div className="w-full flex items-center justify-start overflow-hidden">
            <div className="overflow-x-auto w-full max-w-full flex py-2">
              {file && (
                <div
                  className={`flex items-center border-1.5 rounded-1 border-grey h-[40px] w-1/2 mt-2`}
                >
                  <div className="flex items-center flex-1 px-4 bg-white h-full">
                    <div className="flex items-center gap-x-1">
                      <div className="flex items-center justify-center h-7 w-7 rounded-full bg-grey4">
                        <FileIcon height={16} width={16} />
                      </div>
                      <label className="text-black font-medium text-xs">
                        {file ? file?.name : 'No file chosen'}
                      </label>
                      {getFileContent(file)}
                    </div>
                    <div className="cursor-pointer ml-auto">
                      <TrashIcon height={20} width={20} color="red" onClick={handleRemoveFile} />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="w-1/2 px-3">
          <div className="mb-3">
            <label className="font-medium text-sm text-black w-full">
              {t('offersAndTips.tableHeaders.title')}
              <span className="text-red-500 ml-1 text-base font-bold">*</span>
            </label>
            <InputField
              placeholder={t('offersAndTips.addEdit.titlePlaceholder')}
              value={offersData?.title || ''}
              onChange={val => setOfferData({ ...offersData, title: val })}
              error={error?.title}
            />
          </div>
        </div>
        {!isDealerAdmin && (
          <div className="w-1/2 px-3">
            <div className="mb-3">
              <label className="font-medium text-sm text-black w-full">
                {t('organization.title')}
                <span className="text-red-500 ml-1 text-base font-bold">*</span>
              </label>
              <MultiSelect
                selected={offersData?.organizations || []}
                placeholder={t('offersAndTips.addEdit.organizationPlaceholder')}
                options={organizationOptions || []}
                setSelected={val => setOfferData({ ...offersData, organizations: val })}
                error={error?.organization}
              />
            </div>
          </div>
        )}

        <div className="w-1/2 px-3">
          <div className="mb-3">
            <label className="font-medium text-sm text-black w-full">
              {t('offersAndTips.addEdit.sendAt')}
              <span className="text-red-500 ml-1 text-base font-bold">*</span>
            </label>
            <div className="flex w-full gap-x-2">
              <div className="w-3/4">
                <DatePickerComponent
                  selected={offersData?.publishDate}
                  onChange={date => setOfferData({ ...offersData, publishDate: String(date) })}
                  isAllowPastDate={false}
                  error={error?.publishDate}
                />
              </div>
              <div className="w-1/4">
                <input
                  type="time"
                  value={timeValue}
                  onChange={handleTimeChange}
                  className={`flex relative items-center px-3 h-10 placeholder:text-sm border-1.5 rounded-1 bg-white border-grey focus:border-active outline-none text-base text-black2  placeholder:text-grey2 disabled:bg-grey1 w-fit 
                  }`}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="w-1/2 px-3">
          <div className="mb-3">
            <label className="font-medium text-sm text-black w-full">
              {t('offersAndTips.tableHeaders.type')}
              <span className="text-red-500 ml-1 text-base font-bold">*</span>
            </label>
            <Select
              placeholder={t('offersAndTips.addEdit.typePlaceholder')}
              options={[
                { id: 'offer', name: t('OFFER'), value: 'offer' },
                { id: 'tips', name: t('TIPS'), value: 'tips' },
              ]}
              selected={offersData?.type || null}
              setSelected={data => setOfferData({ ...offersData, type: data })}
              error={error?.type}
              showCross
              handleCross={() => {
                setOfferData({ ...offersData, type: null });
              }}
            />
          </div>
        </div>
        <div className="w-1/2 px-3">
          <div className="mb-3">
            <label className="font-medium text-sm text-black w-full">{t('BRAND')}</label>
            <Select
              placeholder={t('offersAndTips.addEdit.brandPlaceholder')}
              options={brandOptions || []}
              selected={offersData?.brand || null}
              setSelected={data => setOfferData({ ...offersData, brand: data })}
              disabled={false}
              showCross
              handleCross={() => {
                setOfferData({ ...offersData, brand: null });
              }}
              dropdownPlacement="TOP"
            />
          </div>
        </div>

        <div className="w-1/2 px-3">
          <div className="mb-3">
            <label className="font-medium text-sm text-black w-full">{t('ENGINE')}</label>
            <Select
              placeholder={t('offersAndTips.addEdit.enginePlaceholder')}
              options={engineOptions || []}
              selected={offersData?.engine || null}
              setSelected={data => setOfferData({ ...offersData, engine: data })}
              showCross
              handleCross={() => {
                setOfferData({ ...offersData, engine: null });
              }}
              dropdownPlacement="TOP"
            />
          </div>
        </div>
        <div className="w-1/2 px-3">
          <div className="mb-3">
            <label className="font-medium text-sm text-black w-full">
              {t('offersAndTips.addEdit.frontTirePlaceholder')}
            </label>
            <Select
              placeholder={t('offersAndTips.addEdit.frontTirePlaceholder')}
              options={tireSizeOptions || []}
              selected={offersData?.frontTireSize || null}
              setSelected={data => setOfferData({ ...offersData, frontTireSize: data })}
              showCross
              handleCross={() => {
                setOfferData({ ...offersData, frontTireSize: null });
              }}
              dropdownPlacement="TOP"
            />
          </div>
        </div>
        <div className="w-1/2 px-3">
          <div className="mb-3">
            <label className="font-medium text-sm text-black w-full">{t('REAR_TIRE_SIZE')}</label>
            <Select
              placeholder={t('offersAndTips.addEdit.rearTireplaceholder')}
              options={tireSizeOptions || []}
              selected={offersData?.rearTireSize || null}
              setSelected={data => setOfferData({ ...offersData, rearTireSize: data })}
              showCross
              handleCross={() => {
                setOfferData({ ...offersData, rearTireSize: null });
              }}
              dropdownPlacement="TOP"
            />
          </div>
        </div>
      </div>
    </CommonLayout>
  );
};

export default AddEditOffersTips;
